import { defineStore } from "pinia";
import { disableAnalytics, initAnalytics, initPlausible } from "../analytics";

const CONSENT_KEY = "eco_cookie_consent";

interface StoredConsent {
    analytics: boolean;
}

function readStored(): StoredConsent | null {
    try {
        const raw = localStorage.getItem(CONSENT_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return typeof parsed?.analytics === "boolean" ? { analytics: parsed.analytics } : null;
    } catch {
        return null;
    }
}

export const useCookieConsentStore = defineStore("cookieConsent", {
    state: () => ({
        // null пока посетитель (или сохранённый ранее выбор) не определился -
        // CookieConsentBanner.vue считает null равным "выбор не сделан".
        analyticsConsent: null as boolean | null,
        decided: false,
        // true открывает баннер как панель "управление настройками" из
        // Профиль > Настройки, независимо от `decided`.
        settingsOpen: false,
    }),
    actions: {
        // Вызывается один раз из App.vue при монтировании: подгружает и
        // переприменяет ранее сохранённый выбор (например, повторно
        // подключает GA для вернувшегося посетителя) - баннер нужен только
        // для первого визита.
        init() {
            const stored = readStored();
            if (stored) {
                this.analyticsConsent = stored.analytics;
                this.decided = true;
                this.apply();
            }
        },
        acceptAll() {
            this.commit(true);
        },
        rejectNonEssential() {
            this.commit(false);
        },
        saveCustom(analytics: boolean) {
            this.commit(analytics);
        },
        openSettings() {
            this.settingsOpen = true;
        },
        closeSettings() {
            this.settingsOpen = false;
        },
        commit(analytics: boolean) {
            this.analyticsConsent = analytics;
            this.decided = true;
            this.settingsOpen = false;
            localStorage.setItem(CONSENT_KEY, JSON.stringify({ analytics }));
            this.apply();
        },
        apply() {
            if (this.analyticsConsent) {
                initAnalytics();
                initPlausible();
            } else {
                disableAnalytics();
            }
        },
    },
});
